import { AsnCdnService } from '@asn-services/cdn';

import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ApThemeService extends AsnCdnService {
    // Angular wrapper - inherits all methods from core
}
